import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';
import Form from 'core/gd-form/form/form-modal/form-modal';

class ModalActionStoryPoints extends React.Component {

    static propTypes = {
        params: PropTypes.shape({
            item: PropTypes.object,
            onSubmit: PropTypes.func.isRequired,
        })
    }

    constructor(props) {
        super(props);

        const { item } = this.props.params
        const initFormData = {
            storyPoints: item && item.storyPoints ? item.storyPoints : null,
        }

        const formStructure = {
            fields: {
                storyPoints: {
                    type: 'select',
                    isRequired: false
                }
            },
            onSubmit: this.onSubmit
        }

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result) => {
        const { onSubmit } = this.props.params;
        if (onSubmit) onSubmit(result.storyPoints);
    }

    onSelect = (value) => {
        this.form.onFormComponentValueChange('storyPoints', value)
        this.forceUpdate()
    }

    render() {
        const options = gd.session.companies.get(gd.companyId).settings.fields.storyPoints
        const value = this.form.getValue('storyPoints')

        return (
            <Form form={this.form} submitLabel="Submit" >
                <div className="row">
                    <div className="cards">
                        {_.map(options, (option, key)=>
                            <div key={key}
                                 className={Classes("ui5-story-points s-40 m-l-5 m-r-5", {selected: option.value === value})}
                                 onClick={()=>{this.onSelect(option.value)}}>
                                {option.label}
                            </div>)}
                        <div className={Classes("ui5-story-points s-40 m-l-5 m-r-5 not-set", {selected: _.isNil(value)})} onClick={()=>{this.onSelect(null)}}></div>
                    </div>
                </div>
            </Form>
        );
    }
}

module.exports = ModalActionStoryPoints;